"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppManifestLoader = void 0;
const utils_1 = require("@juvare/common-web-ui/utils");
const usePublicDataClient_1 = require("../../ui/hooks/usePublicDataClient");
const react_redux_1 = require("react-redux");
const stores_1 = require("../stores");
const usePreloader_1 = require("./usePreloader");
function useAppManifestLoader() {
    var _a;
    const state = (0, react_redux_1.useSelector)(getAppManifest);
    const dispatch = (0, react_redux_1.useDispatch)();
    const publicDataClient = (0, usePublicDataClient_1.usePublicDataClient)();
    const { status, onReload } = (0, usePreloader_1.usePreloader)({
        status: (_a = state === null || state === void 0 ? void 0 : state.status) !== null && _a !== void 0 ? _a : 'initial',
        onLoad: () => {
            dispatch(stores_1.appManifestSlice.actions.setLoading());
            return publicDataClient.publicDataGetAppManifest();
        },
        onSuccess: (result) => {
            dispatch(stores_1.appManifestSlice.actions.setAppManifest(result));
        },
        onError: (error) => {
            dispatch(stores_1.appManifestSlice.actions.setError((0, utils_1.getErrorMessage)(error)));
        },
    });
    return {
        status: status === 'error' ? 'done' : status,
        onReload,
    };
}
exports.useAppManifestLoader = useAppManifestLoader;
function getAppManifest(state) {
    return state.appManifest.appManifest;
}
